module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/YT-a40b3dd57f8b381b6ae7ff658f99350b.png";